<template>
<div ref="orgnzList">
	<base-header v-once pageName="조직현황보기" :prevBtnShow="true" history="main"></base-header>
	<section id="wrap">
		<div class="search">
			<input type="search" :value="keyword" v-on:input="keyword=$event.target.value" class="search" @keyup.enter ="searchList" placeholder="이름, 휴대폰번호, 사원번호 검색">
			<button type="button" class="search" title="검색" @click="searchList"></button>
			<button type="button" class="search-detail" :class={choice:searchDetailYn} title="상세검색" @click="popSearch(true)"></button>
			<p class="date">
				<span>{{today}}</span> <em>전체 <i>{{tot}}</i>명</em>
			</p>
			<base-sort selectName="정렬선택"
				v-on:sortVal="sortChange"
				:options="ordrList"
				:default="sortDefaultIdx"
			></base-sort>
			<!-- default : 기본선택 할 option의 index번호 -->
		</div>
		<ul class="group-list" v-if="this.list.length > 0">
			<li v-for="(item,index) in list" v-bind:key="item.akdcde">
				<p>
					<em v-bind:class="item.gubun | jicClass"></em>
					<strong @click="goDetail(index)">{{item.akdnam}}</strong>
					<span @click="goDetail(index)">{{item.akdcde}}</span>
					<i>{{item.akdpas == 1 ? "달성":"미달성"}}</i>
				</p>
				<div>
					<b>당월 인정 실적</b>
					<em>{{item.totamt > 3000000 ?	"실활동" : (item.totamt > 0 ? "가동" : "미가동")}}</em>
					<span><i>{{item.totamt | numFormat}}</i> 원</span>
				</div>
			</li>
		</ul>
		<infinite-loading @infinite="infiniteHandler" spinner="waveDots" ref="InfiniteLoading">
            <div slot="no-more"></div>
            <div slot="no-results">
                <div class="search-resutl-None">
                    <p>검색된 정보가 없습니다.</p>
                </div>
			</div>
		</infinite-loading>
    <!-- 2026.09.18 챗봇 버튼-->
      <div class="fltMn">
          <button type="button" class="chatbot allow-click" @click="chatbot"></button>
      </div>
    <!--// 2026.09.18 챗봇 버튼-->
	</section>
</div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
export default {
	name: "OrgnzList",
	components: {
		InfiniteLoading
	},
	data() {
		return{
			today:'',
			list:[],
			tot:0,
			offset: 0,	 //현재 가지고있는 갯수
			size : 10,	 //한번에 가져오는 수
			keyword:'',
			searchkeyword:'',
			gubun:[],
			chawol:[],
			gadong:[],
			ordrList:[{text:'실적높은순',value:'perf'},{text:'사번순',value:'uid'}],
			ordrType: 'perf',
			sortDefaultIdx: 0,
			searchDetailYn: false,
      loginGbn : this.$store.getters.loginGbn, //로그인구분
		};
	},
	watch: {
		'$store.state.ui.child'(child) {	 //////상세검색에서 검색버튼 클릭
			if(child.name == 'orgnz-search-pop'){
				this.gubun =child.data.gubun;
				this.chawol =child.data.chawol;
				this.gadong =child.data.gadong;

				if(child.data.gubun.length < 1
					&& child.data.chawol.length < 1
					&& child.data.gadong.length < 1 ){
					this.searchDetailYn = false
				}else{
					this.searchDetailYn = true
				}
				this.searchList();
			}
		},
		keyword(newVal, oldVal){
			var len = newVal.length;
			if(len > 11)
				this.keyword = oldVal;
		}
	},
	methods: {
		infiniteHandler : function($state){
//			console.log('infiniteHandler SCROLL')
			var that = this;
			var parameters = {
				offset: this.offset,
				size: this.size,
				keyword : this.searchkeyword,
				gubun : this.gubun,
				chawol : this.chawol,
				gadong : this.gadong,
				ordrType : this.ordrType
			};
			this.$api.orgnz
			.list(parameters)
			.then(function(data) {
				//console.log(data);
				that.tot = data.totCnt;
				var list = data.list;
				if (list.length) {
					$state.loaded();
					that.list = that.list.concat(list);
					that.offset += that.size;
					if (list.length < that.size) {
						$state.complete();
					}
					if(that.size > 10){
						that.size = 10
					}
				} else {
					$state.complete();
				}
			})
			.catch(function(error) {
				alert(error.rtMsg);
			});
		},
		popSearch : function(){
			this.$utils.nativeIf.outbound.newPage("/orgStatus/orgStatusList/detailedSearch?gubun="+this.gubun+"&chawol="+this.chawol+"&gadong="+this.gadong);
		},
		searchList : function(){
			this.searchkeyword = this.keyword
			this.totalCnt = 0
			this.offset = 0
			this.size = 10
			this.list = []
			this.$refs.InfiniteLoading.stateChanger.reset();
		},
		goDetail : function(index){
			var item = this.list[index];
			var param = "&gubun="+item.gubun;
			param += "&akdnam="+item.akdnam;

			this.$utils.nativeIf.outbound.newPage("/orgStatus/orgStatusView?targetId="+item.akdcde+param)

		},
		sortChange:function(sortVal){
			this.ordrType = sortVal;
			this.searchList();
		},
    chatbot: function(){
        this.$api.chatbot
        .getChatbotToken()
        .then((token) => {
          this.token = token;
          if(this.token != null){
              // this.$utils.nativeIf.outbound.outlink("https://kyowon-chatbot.ax.dalpha.so/#token="+this.token); //달파 토큰 전송
              window.location.href =  `https://kyowon-chatbot.ax.dalpha.so/#token=${encodeURIComponent(token)}&inpath=WAPLE`;
          }else {
              console.log("else token");
          }
        })
        .catch(function (error) {
          alert(error.rtMsg);
        });
    },
	},
	beforeCreate: function(){
		if(this.$store.getters.orgnzPstn != "COG02" && this.$store.getters.orgnzPstn != "COG01"){
			//권한없음.
			alert("권한없습니다.")
			this.$router.back();
		}
	},
	created: function() {
		var year = new Date().getFullYear();
		var month = new Date().getMonth()+1;
		month = month >= 10 ? month : '0' + month;
		this.today = year+"."+ month;

		if(this.$route.params.option){
			// 메인 > 조직현황 으로 들어왔을경우
			var option = this.$route.params.option
			if(option == 'meetY'){ //미팅참석 달성 우선 노출
				this.ordrType = 'meetY'
				// this.sortDefaultIdx = 1
			}else if(option == 'recruit'){ //1차월 조회
				this.chawol = ['1']
				this.searchDetailYn = true
			}else if(option == 'sil'){ 	//실동 조회
				this.gadong = ['SIL']
				this.searchDetailYn = true
			}else if(option == 'sil1'){ //실동+1차월 조회
				this.gadong = ['SIL']
				this.chawol = ['1']
				this.searchDetailYn = true
			}else if(option == 'sil2'){ //실동+2~3차월 조회
				this.gadong = ['SIL']
				this.chawol = ['2']
				this.searchDetailYn = true
			}
		}
	},
	filters:{
		numFormat:function(num){
			if(num==0) return 0;

			var n = num+'';
			var reg = /(^[+-]?\d+)(\d{3})/;

			while (reg.test(n))
				n = n.replace(reg,'$1'+','+'$2');

			return n;
		},
		jicClass:function(gubun){
			var clss = "";

			if(gubun == 'COG01'){
				clss = "epLv";
			}else if(gubun == 'COG02'){
				clss = "epLv1";
			}else if(gubun == 'COGA2'){
				clss = "epLvA1";
			}else if(gubun == 'COG03'){
				clss = "epLv2";
			}else if(gubun == 'COG04'){
				clss = "epLv3";
			}else if(gubun == 'COG05'){
				clss = "epLv4";
			}else if(gubun == 'COG06'){
				clss = "epLv5";
			}

			return clss;
		}
	}
};
</script>
